import {
  SupportRequestStatusType,
  SupportRequestTypeType,
  type SupportRequestsFilterInputType,
} from "@/types/graphql/partner.generated";
import { isEnumValue } from "@/partner/shared/utils/filterValues";

/**
 * Маппинг значений фильтра из querystring в аргумент запроса обращений.
 * Приём и утилиты те же, что в `features/refunds/model/buildRefundsFilter.ts`.
 */
export function buildSupportRequestsFilter(
  filter: Record<string, unknown>
): SupportRequestsFilterInputType | undefined {
  const result: SupportRequestsFilterInputType = {};

  if (typeof filter.search === "string" && filter.search) {
    result.search = filter.search;
  }

  if (isEnumValue(SupportRequestStatusType, filter.status)) {
    result.status = filter.status;
  }

  if (isEnumValue(SupportRequestTypeType, filter.type)) {
    result.type = filter.type;
  }

  if (filter.needsReply === true || filter.needsReply === "true") {
    result.needsReply = true;
  }

  if (typeof filter.assigneeId === "string" && filter.assigneeId) {
    result.assigneeId = filter.assigneeId;
  }

  return Object.keys(result).length > 0 ? result : undefined;
}
